import { ChevronRight, ExternalLink, MapPin } from 'lucide-react';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";


import Scheduler from "../../scheduler.recommended"; // Ensure this path is correct or adjust as needed
import { createOffer } from "../../../../../../services/staffingService";







import { ReactComponent as InfoCircleGreen } from "../../../../../_asset/img/info-circle_green.svg";
import { ReactComponent as TaskSquare } from "../../../../../_asset/img/task-square.svg";
import { ReactComponent as Star } from "../../../../../_asset/img/star-circle.svg";
import { ReactComponent as DollarCircle } from "../../../../../_asset/img/dollar-circle.svg";
import { ReactComponent as MakeOffer } from "../../../../../_asset/img/make_offer.svg";

// Scrollbar styles for WebKit browsers
const scrollbarStyles = {
  scrollbarWidth: 'thin',
  scrollbarColor: '#D1D5DB #F3F4F6'
};

// Custom Input Number Component to replace RSuite InputNumber
const CustomInputNumber = ({ value, onChange, size = "xs" }) => {
  return (
    <input
      type="number"
      value={value || ""}
      onChange={(e) => onChange(Number(e.target.value) || 0)}
      className="w-16 px-2 py-1 text-xs font-medium text-black bg-white border border-gray-300 rounded outline-none focus:border-primary focus:ring-1 focus:ring-primary"
      min="0"
      step="0.01"
      placeholder="0"
    />
  );
};

// Custom Tag Component to replace RSuite Tag
const CustomTag = ({ children, className = "" }) => {
  return (
    <span className={`inline-block px-1 py-1 text-xs font-semibold text-blue-600 bg-blue-50 rounded ${className}`}>
      {children}
    </span>
  );
};

// Custom Tooltip Component to replace RSuite Tooltip/Whisper
const CustomTooltip = ({ content, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div 
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap z-10">
          {content}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-gray-800"></div>
        </div>
      )}
    </div>
  );
};

function formatShiftDate(dateString, startTime, endTime) {
  const date = new Date(dateString);
  const options = { day: "2-digit", month: "short" };
  const formattedDate = date.toLocaleDateString("en-GB", options);
  const startHours = new Date(startTime).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const endHours = new Date(endTime).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return `${formattedDate}, ${startHours} hrs - ${endHours} hrs`;
}

// Function to format the date to "14 Aug"
function formatCompactShiftDate(dateString) {
  const options = { day: "2-digit", month: "short" };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

// Function to format the full date and time for the tooltip
function formatFullShiftDate(dateString) {
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

const RecommendedListingItems = ({
  providerCompanyId,
  staffs,
  hoveredStaff,
  setStaffs,
  setHoveredStaff,
  ticket,
  job,
  setSelectedOfferId,
  setActiveTab,
  fetchJobAndOfferMetadata
}) => {
  const [activeStaffId, setActiveStaffId] = useState(null);

  // Add scrollbar styles to document head
  React.useEffect(() => {
    const styleId = 'custom-scrollbar-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #F3F4F6;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #D1D5DB;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #9CA3AF;
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  const handleMouseEnter = (staffMember) => {
    setHoveredStaff(staffMember);
  };

  const openModal = (staffId) => {
    setActiveStaffId(staffId);
  };

  const closeModal = () => {
    setActiveStaffId(null);
  };

  const sendOffer = async (staff, job) => {
    try {
      const resp = await createOffer(providerCompanyId, staff, job);
      // const offerId = resp.data.offer._id;
      // const offerStatus = resp.data.offer.status;
      /*
            setStaffs(prevStaffs => {
                return prevStaffs.map(staff => staff._id === resp.data.offer.securityStaffId ? { ...staff, offerId: offerId } : staff);
            });
            */

      setStaffs((prevStaffs) => {
        return prevStaffs.map((staff) => {
          if (staff._id === resp.data.offer.provider_resource_id) {
            return {
              ...staff,
              offer: {
                ...staff.offer,
                offerId: resp.data.offer._id,
                status: resp.data.offer.status,
              },
            };
          }
          return staff;
        });
      });

      setActiveStaffId(null);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data);
      }
    }
  };

  const handleChange = (value, staffId) => {
    setStaffs((prevStaffs) =>
      prevStaffs.map((staff) =>
        staff._id === staffId ? { ...staff, offerPrice: value } : staff
      )
    );
  };

  const handleTabChange = (offerId) => {
    setSelectedOfferId(offerId);
    setActiveTab("2");
    fetchJobAndOfferMetadata();
  };

  return (
    <>
      <div className="flex flex-col gap-2.5 pb-8">
        {staffs.length > 0 && (
          <>
            {["optimized_for_highest_margin", "top_performers_in_area"].map(
              (category) => {
                const staffsInCategory = staffs.filter(
                  (m) => m.category === category
                );

                // Only render the category if it has staff members
                if (staffsInCategory.length === 0) {
                  return null;
                }

                return (
                  <div key={category} className="mb-6">
                    {/* Alert boxes for categories */}
                    {category === "optimized_for_highest_margin" && (
                      <div className="flex items-center gap-2 p-2 rounded-lg bg-green-50 text-black text-base font-normal leading-6 mb-4">
                        <InfoCircleGreen />
                        Recommended for highest margin optimization
                      </div>
                    )}
                    {category === "top_performers_in_area" && (
                      <div className="flex items-center gap-2 p-2 rounded-lg bg-green-50 text-black text-base font-normal leading-6 mb-4">
                        <InfoCircleGreen />
                        Top performers in the area
                      </div>
                    )}

                    {/* Render staff details for each category with scrolling */}
                    <div 
                      className="grid grid-cols-2 gap-4 xl:grid-cols-2 lg:grid-cols-1 font-medium text-xs text-gray-700 max-h-96 overflow-y-auto custom-scrollbar"
                      style={scrollbarStyles}
                    >
                      {staffsInCategory.map((m) => (
                        <div
                          key={m._id}
                          className="border border-gray-300 p-4 rounded-lg bg-white shadow-lg transition-shadow duration-200 hover:shadow-xl cursor-pointer"
                          onClick={() => {
                            setHoveredStaff(m);
                          }}
                        >
                          {/* Title and Margin */}
                          <div className="flex items-center justify-between text-black text-base font-semibold mb-1">
                            {`${m.user_id.firstName} ${m.user_id.lastName}`}
                            <div className="px-2 py-2 rounded-lg bg-gray-100">
                              <span className="text-black text-xs font-medium leading-4">
                                {`${(
                                  ((job.hourlyPayRate - m.offerPrice) /
                                    job.hourlyPayRate) *
                                  100
                                ).toFixed(0)}% Margin`}
                              </span>
                            </div>
                          </div>

                          {/* Address */}
                          <div className="flex items-center gap-2 text-black text-sm font-normal leading-5 mb-4 mt-2">
                            <MapPin className="!w-4 !h-4 text-black" />
                            {`${
                              m.formattedLocation
                            } (${m.distanceMiles?.toFixed(2)} miles away)`}
                          </div>

                          {/* Stats */}
                          <div className="flex items-center gap-2 flex-wrap mb-2">
                            <div className="flex items-center gap-1 px-2 py-2 rounded-full bg-gray-50 text-black text-xs font-medium">
                              <DollarCircle />
                              {`20 jobs done in last 3 months`}
                            </div>
                            <div className="flex items-center gap-1 px-2 py-2 rounded-full bg-gray-50 text-black text-xs font-medium">
                              <Star />
                              {`$${m.preferences.minHourlyRate} per hour `}
                            </div>
                            <div className="flex items-center gap-1 px-2 py-2 rounded-full bg-gray-50 text-black text-xs font-medium">
                              <TaskSquare />
                              4.3
                            </div>
                          </div>

                          {/* Assigned Shifts */}
                          {m.assignedShifts.length > 0 && (
                            <div className="flex items-center justify-between">
                              <span className="text-gray-500 text-xs font-normal">Offered Shifts:</span>
                              <div className="flex flex-wrap gap-1">
                                {m.assignedShifts.map((shift) => (
                                  <CustomTooltip
                                    key={shift._id}
                                    content={`${formatFullShiftDate(
                                      shift.startTime
                                    )} Hrs - ${formatFullShiftDate(
                                      shift.endTime
                                    )} Hrs`}
                                  >
                                    <CustomTag>
                                      {formatCompactShiftDate(shift.date)}
                                    </CustomTag>
                                  </CustomTooltip>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Divider */}
                          <hr className="my-4 border-gray-300 opacity-100" />

                          {/* Make Offer Section */}
                          {!m.offer && (
                            <div className="flex items-center justify-between">
                              <div className="flex items-center ">
                                <span className="text-gray-500 text-xs font-normal">Set Hourly Rate:</span>
                                <div className="flex items-center px-1 py-1 bg-white ">
                                  <span className="text-black text-xs font-medium px-1">$</span>
                                  <CustomInputNumber
                                    size="xs"
                                    value={m.offerPrice}
                                    onChange={(value) => handleChange(value, m._id)}
                                  />
                                </div>
                              </div>
                              
                              {activeStaffId === m._id && (
                                <Scheduler
                                  isOpen={true}
                                  onRequestClose={closeModal}
                                  className="scheduler-modal"
                                  overlayClassName="scheduler-modal-overlay"
                                  ariaHideApp={false}
                                  sendOffer={sendOffer}
                                  staff={m}
                                  job={job}
                                />
                              )}

                              <div
                                onClick={() => openModal(m._id)}
                                className="flex items-center gap-2 px-3 py-3 rounded-lg bg-primary text-white text-xs font-semibold cursor-pointer hover:opacity-90 transition-opacity"
                              >
                                Make Offer <MakeOffer />
                              </div>
                            </div>
                          )}

                          {/* Offer Status */}
                          {m.offer?.offerId && (
                            <div className="flex justify-end">
                              <div
                                className="font-medium cursor-pointer"
                                onClick={() => {
                                  handleTabChange(m.offer.offerId);
                                }}
                              >
                                {m.offer.status === "completed" && (
                                  <span className="text-green-600">
                                    Pending Payment{" "}
                                    <ChevronRight />
                                  </span>
                                )}
                                {m.offer.status === "paid" && (
                                  <span className="text-green-600">
                                    Payment Completed{" "}
                                    <ChevronRight />
                                  </span>
                                )}
                                {m.offer.status === "accepted" && (
                                  <span className="text-green-600">
                                    Offer Accepted{" "}
                                    <ChevronRight />
                                  </span>
                                )}
                                {m.offer.status === "rejected" && (
                                  <span className="text-red-600">
                                    Offer Rejected{" "}
                                    <ChevronRight />
                                  </span>
                                )}
                                {m.offer.status === "expired" && (
                                  <span className="text-red-600">
                                    Offer Expired{" "}
                                    <ChevronRight />
                                  </span>
                                )}
                                {m.offer.status === "open" && (
                                  <span className="text-yellow-500 text-xs">
                                    Pending Response{" "}
                                    <ExternalLink className="!text-sm" />
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              }
            )}
          </>
        )}
      </div>
    </>
  );
};

export default RecommendedListingItems;
